import { Link } from 'react-router-dom';
import { categories, cases } from '@/mocks/cases';
import SectionHeading from './SectionHeading';

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Topics"
          title="按主题找爆料"
          desc="从直播圈到带货电商，从合约纠纷到售后争议，按你关心的领域快速筛选已收录的材料。"
          actionText="全部主题"
          actionTo="/cases"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => {
            const count = cases.filter((c) => c.categoryId === cat.id).length;
            return (
              <Link
                key={cat.id}
                to={`/cases?cat=${cat.id}`}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className={`${cat.icon} text-xl`}></i>
                  </span>
                  <span className="rounded-md bg-secondary-100 px-2 py-1 text-xs text-secondary-800">{count} 条材料</span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950 group-hover:text-primary-600">
                  {cat.name}
                </h3>
                <p className="mt-1.5 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm text-primary-600">
                  进入分类
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}